import classNames from 'classnames'

import LoadingButton from '../LoadingButton/LoadingButton'

import { SurgeryBoxProps } from './SurgeryBox.types'
import './SurgeryBox.scss'
import CaseInformation from 'components/ProcedureList/CaseInformation'

const SurgeryBox = ({
  surgery,
  onClick,
  isSelected,
  disableSelect,
}: SurgeryBoxProps) => {
  return (
    <div
      className={classNames('surgery-box-molecule_wrapper', {
        selected: isSelected,
      })}
    >
      <div className="details">
        {surgery && <CaseInformation surgery={surgery} showDate={true} />}
      </div>

      <LoadingButton
        disabled={surgery.status.name === 'SUBMITTED' || disableSelect}
        loading={false}
        mode={isSelected && !disableSelect ? 'delete' : 'default'}
        onClick={onClick}
      >
        {surgery.status.name === 'SUBMITTED'
          ? 'Case Submitted'
          : isSelected
          ? disableSelect
            ? 'Selected'
            : 'Remove Selection'
          : 'Select Surgery'}
      </LoadingButton>
    </div>
  )
}

export default SurgeryBox
